export const IrFutureConvention = {
  TickSize: 'Tick Size Convention',
  FixedIncome: 'Fixed Income Convention',
} as const;

export type IrFutureConvention = (typeof IrFutureConvention)[keyof typeof IrFutureConvention];

export const irFutureConventionTranslation: Record<IrFutureConvention, { path: string }> = {
  [IrFutureConvention.TickSize]: { path: 'CONSTITUENT_RISK.PARAMETERS_MODAL.IR_FUTURE_TICK_SIZE' },
  [IrFutureConvention.FixedIncome]: { path: 'CONSTITUENT_RISK.PARAMETERS_MODAL.IR_FUTURE_FIXED_INCOME' },
};
